// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__1Vpjk","EnvWarning":"Logo_EnvWarning__piq6E"};